<template>
  <div>
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="24">
        <el-col :span="6">
          <el-input placeholder="请输入姓名或手机号" v-model="queryInfo.cdit" clearable @clear="queryUserEdutrainList"></el-input>
        </el-col>
        <el-col :span="5.5">
          <el-date-picker v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp" :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <el-select v-model="queryInfo.edutrain_level_no" placeholder="学历">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-button type="success" icon="el-icon-search" @click="queryUserEdutrainList">搜索</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="12" style="margin-top:20px;">
        <el-col :span="4.5">
          <el-radio-group v-model="queryInfo.type" @change="queryUserEdutrainList">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button :label="1">文凭</el-radio-button>
            <el-radio-button :label="3">非文凭</el-radio-button>
          </el-radio-group>
        </el-col>
        <el-col :span="4.5">
          <el-radio-group v-model="queryInfo.status"  @change="queryUserEdutrainList">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button :label="1">正常</el-radio-button>
            <el-radio-button :label="0">删除</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>

      <!-- 用户列表区域 -->
      <el-table :data="tableData" stripe>
        <el-table-column prop="id" v-if="hide"></el-table-column>
        <el-table-column type="index" label="序号" min-width="80"></el-table-column>
        <el-table-column label="学校/机构 专业 学历" min-width="200">
          <template slot-scope="scope">
            <div>{{scope.row.org_name}}</div>
            <div>{{scope.row.major_name}} {{scope.row.edutrain_level_no}}</div>
          </template>
        </el-table-column>
        <el-table-column label="起止时间" min-width="175">
          <template slot-scope="scope">
            <div>起始：{{scope.row.from_dt | formatDate}}</div>
            <div>终止：{{scope.row.to_dt | formatDate}}</div>
          </template>
        </el-table-column>
        <el-table-column label="指导老师" prop="teacher_name" min-width="100"></el-table-column>
        <el-table-column label="类型" min-width="80">
          <template slot-scope="scope">
            <span :style="scope.row.type == '文凭'? 'color:#6FC334':'color:#EB5753'">{{scope.row.type}}</span>
          </template>
        </el-table-column>
        <el-table-column label="主账号" min-width="175" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button type="text" @click="specQuery(scope.row.user_phoneno)">
              <div style="text-align: left;line-height: 20px;">{{scope.row.user_name}}</div>
              <div style="text-align: left;line-height: 20px;">{{scope.row.user_phoneno}}</div>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="80">
          <template slot-scope="scope">
            <span :style="scope.row.status == '正常'?'color:#6FC334':'color:#EB5753'">{{scope.row.status}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="175">
          <template slot-scope="scope">
            <el-button-group>
              <el-button size="medium" type="warning" :disabled="scope.row.status == '删除' ? true :false" @click="showEditDialog(scope.row)">修改</el-button>
              <el-button size="medium" type="danger" :disabled="scope.row.status == '删除' ? true :false" @click="removeUserEdutrainById(scope.row.id)">删除</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <div style="text-align: right">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.page_ix" :page-size="queryInfo.page_size" layout="prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </el-card>

    <!-- 添加用户的对话框 -->
    <el-dialog :title="formTitle" :visible.sync="dialogFormVisible" width="50%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="wordForm" :rules="wordFormRules" ref="wordForm" label-width="70px">
        <el-form-item label="姓名">
          <el-input v-model="wordForm.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="wordForm.phoneno" disabled></el-input>
        </el-form-item>
        <el-form-item label="学校/机构名称" prop="org_name">
          <el-input v-model="wordForm.org_name"></el-input>
        </el-form-item>
        <el-form-item label="专业" prop="major_name">
          <el-input v-model="wordForm.major_name"></el-input>
        </el-form-item>
        <el-form-item label="学历" prop="edutrain_level_no">
          <el-select v-model="wordForm.edutrain_level_no" placeholder="学历">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学历类型">
          <el-radio-group v-model="wordForm.type">
            <el-radio :label="1">文凭</el-radio>
            <el-radio :label="3">非文凭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="入学时间" prop="from_dt">
          <el-date-picker v-model="wordForm.from_dt" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日" value-format="timestamp">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="毕业时间" prop="to_dt">
          <el-date-picker v-model="wordForm.to_dt" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日" value-format="timestamp">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="指导老师" prop="experience_desc">
          <el-input v-model="wordForm.teacher_name"></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('wordForm',add_edit)">保存设置</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    // 验证手机号的规则
    var checkMobile = (rule, value, cb) => {
      // 验证手机号的正则表达式
      const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/

      if (regMobile.test(value)) {
        return cb()
      }

      cb(new Error('请输入合法的手机号'))
    }

    return {
      hide: false,
      value1: '',
      type: '',
      formTitle: '',
      add_edit: '',
      // 获取用户列表的参数对象
      queryInfo: {
        edutrain_level_no: '',
        status: '1',
        type: '',
        cdit: '',
        from_dt: '',
        to_dt: '',
        // 当前的页数
        page_ix: 1,
        // 当前每页显示多少条数据
        page_size: 10
      },
      tableData: [],
      total: 10, // 分页总数
      // 控制添加用户对话框的显示与隐藏
      dialogFormVisible: false,
      // 用户的表单数据
      wordForm: {
        edutrain_id: '',
        type: '',
        edutrain_level_no: '',
        from_dt: '',
        to_dt: '',
        major_name: '',
        org_name: '',
        teacher_name: '',
        name: '',
        phoneno: ''
      },
      // 添加表单的验证规则对象
      wordFormRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phoneno: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ]
      },
      options: [{
        value: '',
        label: '不限制'
      }, {
        value: '高中',
        label: '高中'
      }, {
        value: '大专',
        label: '大专'
      }, {
        value: '本科',
        label: '本科'
      }, {
        value: '硕士',
        label: '硕士'
      }, {
        value: '博士',
        label: '博士'
      }]
    }
  },
  created() {
    this.specQuery(this.$route.query.phone)
  },
  methods: {
    specQuery(phone = '') {
      this.queryInfo.cdit = phone
      this.queryUserEdutrainList()
    },
    async queryUserEdutrainList() {
      if (this.value1) {
        this.queryInfo.from_dt = Math.floor(this.value1[0] / 1000)
        this.queryInfo.to_dt = Math.floor(this.value1[1] / 1000)
      } else {
        this.queryInfo.from_dt = ''
        this.queryInfo.to_dt = ''
      }
      this.$axios.post('/admin/User/queryUserEdutrain', this.queryInfo).then(res => {
        if (res.data.rst == 0) {
          this.tableData = res.data.data.data
          this.total = res.data.data.total
          this.tableData.forEach(e => {
            e.type = e.type == '1' ? '文凭' : '非文凭'
            e.status = e.status == '1' ? '正常' : '删除'
          })
        } else {
          this.alertError(res.data.msg)
        }
      }).catch(err => {
        console.error('错误：', err)
      })
    },
    // 监听 page_size 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.page_size = newSize
      this.queryUserEdutrainList()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      // console.log(newPage)
      this.queryInfo.page_ix = newPage
      this.queryUserEdutrainList()
    },
    // 监听用户对话框的关闭事件
    addDialogClosed() {
      this.$refs.wordForm.resetFields()
    },
    // 展示编辑用户的对话框
    showEditDialog(row) {
      this.formTitle = '教育培训'
      this.add_edit = 'edit'
      this.dialogFormVisible = true
      Object.assign(this.wordForm, row)
      let std = row.type == '文凭' ? 1 : 3
      this.wordForm.type = std
      let to_dt = row.to_dt * 1000
      let from_dt = row.from_dt * 1000
      this.wordForm.is_onjob = std
      this.wordForm.to_dt = to_dt
      this.wordForm.from_dt = from_dt
      // console.log('this.wordForm ',this.wordForm )
    },
    // 提交表单
    submitForm(formName, type) {
      // // 开启登录加载动画
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (type == 'edit') {
            // let sta = this.wordForm.type == "文凭" ? 1 : 3;
            let editparams = {
              edutrain_id: this.wordForm.id,
              type: this.wordForm.type,
              edutrain_level_no: this.wordForm.edutrain_level_no,
              from_dt: this.wordForm.from_dt / 1000,
              to_dt: this.wordForm.to_dt / 1000,
              major_name: this.wordForm.major_name,
              org_name: this.wordForm.org_name,
              teacher_name: this.wordForm.teacher_name
            }
            this.$axios.post('/admin/User/saveUserEdutrain', editparams).then(res => {
              if (res.data.rst == 0) {
                this.alertSuccess(res.data.msg)
                this.queryUserEdutrainList()
                this.dialogFormVisible = false
              } else {
                this.alertError(res.data.msg)
              }
            }).catch(err => {
              console.error('错误：', err)
            })
          }
        } else {
          return false
        }
      })
    },
    // 根据Id删除对应的用户信息
    async removeUserEdutrainById(id) {
      // 弹框询问用户是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将删除所选内容, 是否继续?',
        '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      let editparams = {
        edutrain_id: id,
        status: this.queryInfo.status
      }
      this.$axios.post('/admin/User/removeUserEdutrain', editparams).then(res => {
        if (res.data.rst == 0) {
          this.alertSuccess(res.data.msg)
          this.queryUserEdutrainList()
        } else {
          this.alertError(res.data.msg)
        }
      }).catch(err => {
        console.error('错误：', err)
      })
    },
    // 名片跳转
    cardRout(phone) {
      this.$router.push({ name: 'card', query: { phone: phone } })
    },
    // 成功弹窗
    alertSuccess(msg) {
      this.$message.success({
        showClose: true,
        duration: 1000,
        message: msg,
        type: 'success'
      })
    },
    // 错误消息
    alertError(msg) {
      this.$message.error({
        duration: 1000,
        showClose: true,
        message: msg,
        type: 'error'
      })
    }
  }

}
</script>

<style lang="less" scoped>

</style>
